import * as Sentry from "@sentry/react";
import protectedAxios from "../axios";
import { API_URL } from "../constants";

export const shortListProgram = async ({
  userId,
  program,
  reason,
  isShortlisted,
}) => {
  try {
    const payload = {
      userId,
      programId: program.programId,
      programSlug: program.slug,
      reason,
      isShortlisted,
    };

    const { data } = await protectedAxios.post(
      `${API_URL}/v1/program-finder/shortlist`,
      payload
    );

    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getShortListedPrograms = async ({
  userId,
  limit = 50,
  skip = 0,
}) => {
  try {
    if (userId) {
      const { data } = await protectedAxios.get(
        `${API_URL}/v1/program-finder/shortlist/${userId}?limit=${limit}&skip=${skip}`
      );

      return data;
    }
    throw new Error("Invalid userId");
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getAllPrograms = async ({
  search = "",
  limit = 15,
  page = 0,
  useLLM = false,
}) => {
  try {
    let apiUrl = `${API_URL}/v1/program-finder/program/all?limit=${limit}&page=${page}&useLLM=${useLLM}`;
    if (search?.length) {
      apiUrl += `&search=${search}`;
    }
    const { data } = await protectedAxios.get(apiUrl);
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const removeProgramFromShortList = async (shortListItemId) => {
  try {
    const { data } = await protectedAxios.delete(
      `${API_URL}/v1/program-finder/shortlist/${shortListItemId}`
    );

    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const reactivateShortListedProgram = async (shortListItemId) => {
  try {
    const { data } = await protectedAxios.patch(
      `${API_URL}/v1/program-finder/shortlist/${shortListItemId}/reactivate`
    );

    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getCSVData = async (userId) => {
  try {
    const { data } = await protectedAxios.get(
      `${API_URL}/v1/program-finder/shortlist/csv-data/${userId}`
    );

    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const requestShortlist = async (userId) => {
  try {
    const { data } = await protectedAxios.get(
      `${API_URL}/v1/program-finder/shortlist/request/${userId}`
    );

    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getRecommendedPrograms = async (payload) => {
  try {
    const { data } = await protectedAxios.post(
      `${API_URL}/v1/program-finder/shortlist/generate/`,
      { formData: payload }
    );
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const generateAndAddPrograms = async (payload) => {
  try {
    const { data } = await protectedAxios.post(
      `${API_URL}/v1/program-finder/shortlist/generateAndAddShortlist/`,
      { formData: payload }
    );
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getReason = async ({ query, inputs }) => {
  try {
    const apiPromise = protectedAxios.get(
      `${API_URL}/v1/program-finder/shortlist/reasoning?programName=${query}&userInputs=${inputs}`
    );
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const delayPromise = delay(0);

    const [response] = await Promise.all([apiPromise, delayPromise]);

    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getUserPlannerData = async (gamePlayerId) => {
  try {
    if (!gamePlayerId) {
      throw new Error("Gameplayer id not found");
    }

    const { data } = await protectedAxios.get(
      `${API_URL}/v1/program-finder/user?gamePlayerId=${gamePlayerId}`
    );

    const plannerId = data?.plannerId || null;
    const plannerFormData = data?.metadata?.plannerformData || null;

    return { plannerId, plannerFormData };
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};
